<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>To my late Mom and Dad,</p>
<p>I conceived the idea of writing this book to honor you,</p>
<p>But you were called to your Maker,</p>
<p>Long before I even began the writing process.</p>
<p>The writing is now over,</p>
<p>And here is the book,</p>
<p>It’s yours, Mom and Dad,</p>
<p>In memory of your sacrifices and dedication to my upbringing.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?2df38dca